import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { ITaFormlyGuidance, ITaFormlyTemplateOptions } from '@models/types';

const TAG = 'QuestionGuidanceComponent';

@Component({
    selector: 'app-question-guidance',
    templateUrl: 'question-guidance.html',
    styleUrls: ['question-guidance.scss'],
    standalone: false
})
export class QuestionGuidanceComponent implements OnInit {

    @Input() props: ITaFormlyTemplateOptions;
    public guidance: ITaFormlyGuidance = { text: '', images: [] };
    public learnMore: { text: string } = { text: '' };


    constructor(
        public httpClient: HttpClient,
        public modalCtrl: ModalController
    ) { }

    async ngOnInit() {
        this.guidance = this.props.guidance;
        this.learnMore = this.props.learnMore;
    }

}
